export const GENDER_OPTIONS = [
  {
    value: "male",
    description: "Male",
  },
  {
    value: "female",
    description: "Female",
  },
];

export const MARITAL_STATUS_OPTIONS = [
  {
    value: "single",
    description: "Single / Bekar",
  },
  {
    value: "married",
    description: "Married / Evli",
  },
  {
    value: "divorced",
    description: "Divorced / Boşanmış",
  },
  {
    value: "widowed",
    description: "Widowed / Dul",
  },
];
